import JsonScreenHoc from "./JsonScreenHoc";

export default JsonScreenHoc;